import * as AppStore from './AppStore';

export const store = AppStore.store;
export const save = AppStore.save;
